/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Gallery_Desc_GithubInputs */



/**
* | output |
* | --- |
* | "Bring repositories and code into a space." |
*
* @param {Spaces_Gallery_Desc_GithubInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_gallery_desc_github = /** @type {((inputs?: Spaces_Gallery_Desc_GithubInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Gallery_Desc_GithubInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Repositories und Code in einen Space holen.")
	return /** @type {LocalizedString} */ ("Bring repositories and code into a space.")
});